import React, { Component } from 'react';
import Table from 'components/Table/Table';
import { api } from '../../services/api';
import Button from 'components/CustomButtons/Button.js';
import Search from '@material-ui/icons/Search';
import SearchForm from 'components/Search/SearchEvents';
import Circular from 'components/Circular/Circular';
import { getSlots } from '../../services/slots/slots'

import { format, addHours } from 'date-fns'

class EventsFabrika extends Component {
  constructor(props) {
    super(props);

    this.state = {
      circular: true,
      showForm: false,
      showButtonSearch: true,
      finalResultAPI: [],
      lockerAPI: [],
      codeAndOperations: null,
      portaFilter: null,
      mapSlots: {}
    };
  }

  componentDidMount() {

    getSlots(this.props.lockerId, (slots) => {
      let mapSlots = new Map();
      slots.forEach(slot => {
        mapSlots.set(slot.slotName, slot.label);
      });

      this.setState({ mapSlots }, () => {
        const urlTest = `/lockers/${this.props.lockerId}/events`;

        api.get(urlTest).then((res) =>
          this.setState({
            lockerAPI: res.data.data
              // .filter((res) => res.code < 50)
              .sort((a, b) => b.date.localeCompare(a.date)),

            finalResultAPI: res.data.data
              // .filter((res) => res.code < 50)
              .sort((a, b) => b.date.localeCompare(a.date)),
            circular: false,
          }),
        );
      });
    })

  }

  handleFilterTable = (field, value, codeValue, portaValue) => {
    const { finalResultAPI } = this.state;

    let filteredData;

    if (codeValue && portaValue) {
      filteredData = finalResultAPI.filter(
        (el) =>
          el.code === codeValue &&
          el.parametro1 === portaValue
      );

      return this.setState({
        lockerAPI: filteredData,
        showForm: false,
        showButtonSearch: true,
      });
    }

    if (codeValue && !portaValue) {
      filteredData = finalResultAPI.filter(
        (el) =>
          el.code === codeValue
      );

      return this.setState({
        lockerAPI: filteredData,
        showForm: false,
        showButtonSearch: true,
      });
    }

    if (!codeValue && portaValue) {
      filteredData = finalResultAPI.filter(
        (el) =>
        el.parametro1 === portaValue
      );

      return this.setState({
        lockerAPI: filteredData,
        showForm: false,
        showButtonSearch: true,
      });
    }

    filteredData = finalResultAPI.filter((data) => data[field] === value);
    this.setState({ lockerAPI: filteredData, showForm: false, showButtonSearch: true });

  };

  handleSearch = () => {
    const { finalResultAPI, showForm } = this.state;

    const codeAndOperation = [];
    const portaFilter = [];

    const map = new Map();
    const mapPorta = new Map();
    for (const item of finalResultAPI) {
      if (!map.has(item.code)) {
        map.set(item.code, true);
        if (item.code && item.complemento) {
          codeAndOperation.push({
            codigo: item.code,
            operacao: (!item.complemento) ? null : item.complemento.replace(/[0-9]/g, 'X'),
          });
        }
      }

      if (!mapPorta.has(item.parametro1)) {
        mapPorta.set(item.parametro1, true);
        portaFilter.push({
          portaFilter: item.parametro1
        })
      }
    }

    console.log(portaFilter)

    this.setState({
      showForm: !showForm,
      showButtonSearch: false,
      lockerAPI: finalResultAPI,
      codeAndOperations: codeAndOperation.sort((a, b) => a.codigo - b.codigo), //.sort((a, b) => a.codigo.localeCompare(b.codigo)),
      portaFilter: portaFilter
    });
  };

  render() {
    // console.log(this.state.lockerAPI);

    const dataColumn = ['Id', 'Evento', 'Porta', 'Gerado em'];

    const dataTable = this.state.lockerAPI.map((data) => [
      data.code,
      data.complemento ? data.complemento : '-',
      data.parametro1,
      // (data.parametro1 && (data.parametro1.includes("eth") || data.parametro1.includes("wlan"))) ? data.parametro1 : (data.parametro1 ? this.state.mapSlots.get(data.parametro1) : ""),
      format(addHours(new Date(data.createdAt), 3), "dd/MM/yy HH:mm:ss")
    ]);

    const { showButtonSearch, showForm, circular, codeAndOperations, portaFilter } = this.state;

    return circular ? (
      <Circular />
    ) : (
      <div>
        <SearchForm
          show={showForm}
          filterTable={this.handleFilterTable}
          codeAndOperations={codeAndOperations}
          portaFilter={portaFilter}
        />
        <div style={{ display: 'flex', flexDirection: 'row-reverse' }}>
          <Button onClick={this.handleSearch} color="primary" show={showButtonSearch}>
            <Search />
            PESQUISA
          </Button>
        </div>
        <Table
          tableHead={dataColumn}
          tableData={dataTable.length > 0 ? dataTable : [['Nada encontrado']]}
          tableHeaderColor="primary"
        />
      </div>
    );
  }
}
export default EventsFabrika;
